import { render } from "./MenuTree.vue?vue&type=template&id=db6e5386&scoped=true&ts=true"
import script from "./MenuTree.vue?vue&type=script&lang=ts"
export * from "./MenuTree.vue?vue&type=script&lang=ts"

import "./MenuTree.vue?vue&type=style&index=0&id=db6e5386&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db6e5386"]])

export default __exports__